export function authHeader() {
    // return authorization header with jwt token
    var user = localStorage.getItem('user')

    if (user) {
        return { 'Authorization': user };
    } else {
        return {};
    }
}